const serviceIdFromStorage = localStorage.getItem('serviceId')

const serviceIdReducer = (
    state:any = serviceIdFromStorage ? serviceIdFromStorage : '3',
    action:any
) => {
    const { type, payload } = action;
    switch (type) {
        case "SET_SERVICE_ID":
            return payload;
        default:
            return state;
    }
};

export {serviceIdReducer}